export const STATIC_URL = '//static.xdx.app/image/'

export const SITE_URL = '//xdx.app'
export const APP_URL = '//app.xdx.app/'
